<script setup lang="ts">
import { type RouteDescription } from 'types';

defineProps<{
    description: RouteDescription
}>();
</script>

<template>
    RouteDescription
</template>